import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/hooks"
import { PrimaryButton } from "./buttons/PrimaryButton";
import LanguageSelector from "./main_page/LanguageSelector"
import { MainMenuButton } from "./navbar/MainMenuButton"
import { SearchBar } from "./navbar/SearchBar"
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import logo from '../assets/images/Rentic_logo.svg';
import MenuIcon from '@mui/icons-material/Menu';
import { NavLink } from 'react-router-dom';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import HandymanIcon from '@mui/icons-material/Handyman';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import { UserRole } from "../dto/auth/User";
import { Categories } from "./main_page/Categories";
import { NotificationsButton } from "./navbar/NotificationsButton";
import { MenuElement } from "./navbar/MenuElement";
import { logUserOut } from '../store/features/authSlice';


export const NavBarMobile: React.FC = () => {
    const user = useAppSelector(state => state.auth.user);
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation(); // Get the current route
    const dispatch = useAppDispatch();


    useEffect(() => {
        const handleScroll = () => {
            // Only apply logic on the specific page
            if (location.pathname === '/') {
                const viewportHeight = window.innerHeight * 0.4; // 40vh in pixels
                if (window.scrollY > viewportHeight) {
                    setScrolled(true);
                } else {
                    setScrolled(false);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [location.pathname]);

    const handleCloseMenu = () => {
        setMenuOpen(false);
    }

    const handleLogout = () => {
        dispatch(logUserOut());
    }

    return (
        <div className="relative z-50">
            <div className="h-[60px]"></div>
            <div className={`w-full flex justify-center z-10 shadow-main h-14 top-0 px-4 fixed transition-all duration 200 bg-white rounded-b-xl`}>
                <div className="flex w-full justify-between max-w-[1500px]">

                    <div className="flex flex-row items-center space-x-2">

                        <div>
                            <div onClick={() => { setMenuOpen(!menuOpen) }} className="z-40 relative">
                                <MenuIcon />
                            </div>
                            <div className={`flex flex-col justify-between fixed w-full h-full left-0 z-30 p-4 pt-[100px] text-left bg-white transition-all duration-300 ${menuOpen ? "top-0" : "top-[-200vh]"}`}>

                                <div className="basis-3/5 flex flex-col gap-4 pt-6 border-t-[1px] border-primary">
                                    <div className="flex flex-row gap-4">
                                        {!user &&
                                            <div className="w-full">
                                                <PrimaryButton onClick={() => { navigate("/login"); setMenuOpen(false) }} title="Logi sisse"></PrimaryButton>
                                            </div>}
                                        <div className="w-full">
                                            <PrimaryButton outlined={true} title={"Loo kuulutus"} onClick={() => { navigate("/edit"); setMenuOpen(false) }} />
                                        </div>
                                    </div>

                                    <div>
                                        <div className='flex flex-col w-full text-start justify-start z-10 rounded-xl pb-4'>
                                            <NavLink
                                                to="/"
                                                className={({ isActive, isPending }) =>
                                                    isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                                }
                                                onClick={() => setMenuOpen(false)}>
                                                <MenuElement>
                                                    Otsing
                                                </MenuElement>
                                            </NavLink>
                                            {user?.id ?
                                                <div>
                                                    <NavLink
                                                        to="/my-orders"
                                                        className={({ isActive, isPending }) =>
                                                            isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                                        }
                                                        onClick={() => setMenuOpen(false)}>
                                                        <MenuElement>
                                                            Minu laenutatud
                                                        </MenuElement>
                                                    </NavLink>
                                                    <NavLink
                                                        to="/rentals-chats"
                                                        className={({ isActive, isPending }) =>
                                                            isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                                        }
                                                        onClick={() => setMenuOpen(false)}>
                                                        <MenuElement subItem={true}>
                                                            Vestlused
                                                        </MenuElement>
                                                    </NavLink>
                                                    <div className="w-full bg-primary h-[1px] opacity-50 my-2"></div>
                                                    <NavLink
                                                        to="/my-adverts"
                                                        className={({ isActive, isPending }) =>
                                                            isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                                        }
                                                        onClick={() => setMenuOpen(false)}>

                                                        <MenuElement>
                                                            Kõik kuulutused
                                                        </MenuElement>
                                                    </NavLink>
                                                    <NavLink
                                                        to="/my_rentals_status"
                                                        className={({ isActive, isPending }) =>
                                                            isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                                        }
                                                        onClick={() => setMenuOpen(false)}>

                                                        <MenuElement>
                                                            Aktiivsed rendid
                                                        </MenuElement>
                                                    </NavLink>
                                                    <NavLink
                                                        to="/chats"
                                                        className={({ isActive, isPending }) =>
                                                            isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                                        }
                                                        onClick={() => setMenuOpen(false)}>
                                                        <MenuElement subItem={true}>
                                                            Vestlused
                                                        </MenuElement>
                                                    </NavLink>
                                                    <div className="w-full bg-primary h-[1px] opacity-50 my-2"></div>
                                                    <NavLink
                                                        to="/favorites"
                                                        className={({ isActive, isPending }) =>
                                                            isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                                        }
                                                        onClick={() => setMenuOpen(false)}>

                                                        <MenuElement>
                                                            Meeldivaks märgitud
                                                        </MenuElement>
                                                    </NavLink>
                                                    {user.role === UserRole.ADMIN &&
                                                        <NavLink
                                                            to="/admin"
                                                            className={({ isActive, isPending }) =>
                                                                isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                                            }
                                                            onClick={() => setMenuOpen(false)}>

                                                            <MenuElement>
                                                                Adminleht
                                                            </MenuElement>
                                                        </NavLink>
                                                    }
                                                    <NavLink
                                                        to="/profile_edit"
                                                        className={({ isActive, isPending }) =>
                                                            isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                                        }
                                                        onClick={() => setMenuOpen(false)}>

                                                        <MenuElement>
                                                            Profiil
                                                        </MenuElement>
                                                    </NavLink>
                                                </div>
                                                : null}

                                            <div className={`${!user ? "hidden" : ""} text-red-800 `} onClick={handleLogout}>
                                                <MenuElement>
                                                    <div>
                                                        Logi Välja
                                                    </div>
                                                </MenuElement>
                                            </div>
                                            <div></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex flex-col basis-2/5 justify-end pb-4 gap-3">
                                    <div className="flex items-center">
                                        {/* <LanguageSelector /> */}

                                    </div>
                                    <div className="flex basis-1/5 items-center">
                                        <img src={logo} alt="" className="w-[160px] h-full" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {user?.id &&
                            <NotificationsButton />}

                    </div>
                    <div className="flex items-end text-xl cursor-pointer "><div onClick={() => navigate("/")} className="h-full">
                        <img src={logo} alt="" className="h-full" />
                    </div>
                    </div>
                </div>
            </div>
        </div>

    )
}